// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/dist/css/ionicons.min.css
// module id = 1515
// module chunks = 81